import { useEffect } from 'react';
import { usePrefs } from '../../application/stores/prefsStore';

/** Applies the theme preference to <html data-theme> and the language to <html lang>. */
export function ThemeController() {
  const theme = usePrefs((s) => s.theme);
  const locale = usePrefs((s) => s.locale);

  useEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && !!media?.matches);
      document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    };
    apply();
    media?.addEventListener?.('change', apply);
    return () => media?.removeEventListener?.('change', apply);
  }, [theme]);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
